<script>
import {relatorioCertidaoPublicacao} from "@/domain/leiloes/services"
import RelatorioTemplate from "./RelatorioTemplate"

export default {
  mixins: [RelatorioTemplate],
  nome: 'LeilaoRelatorioCertidaoPublicacao',
  created() {
    this.isLoading = true
    relatorioCertidaoPublicacao(this.leilao.id)
        .then((response) => {
          this.dados = response.data
          this.isLoading = false
        })
        .catch((response) => {
          // this.isLoading = false
          this.alertApiError(response)
          console.log(response)
        })
  }
}
</script>
